import SupportCard from './SupportCard';

export { SupportCard };
